import React from "react";
import { useSelector, useDispatch } from "react-redux";
// import slugify from "slugify";
import { useTranslation } from "react-i18next";

// Components
// import ForceModal from "../../../components/UI/Modal/ForceModal";

//
// import { generateXMLString } from "../../../utils/functions/xml";
// import FormActions from "../../../store/actions/FormActions";

const StatusBar = ({
  errors,
  validateClicked,
  setValidateClicked,
  checkboxList,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isCheckboxValid = checkboxList.isValid;

  const errorsArray = Object.keys(errors || {});
  const isOnlyEpisodeError =
    errorsArray.length === 1 &&
    errorsArray[0] === "episodes" &&
    isCheckboxValid;
  const isError = errorsArray.length !== 0 || !isCheckboxValid;
  const isEpisodeError = Boolean(errorsArray.find((e) => e === "episodes"));

  let invalidEpisodes = 0;
  if (isEpisodeError && Array.isArray(errors.episodes)) {
    invalidEpisodes = errors.episodes.filter(
      (ep) => typeof ep === "object"
    ).length;
  }

  // For Export
  // const { form, isValid, fileName } = useSelector((state) => state.form);

  // const { activeCheckboxes, activeChildrens, ...rest } = form;
  // const downloadXMLUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(
  //   generateXMLString(rest, activeCheckboxes, activeChildrens)
  // )}`;
  // const downloadFileName = `${slugify(form?.title || "sample", {
  //   lower: true,
  //   strict: true,
  // })}.xml`;

  // const exportXMLHandler = (e) => {
  //   if (isValid) {
  //   } else {
  //     dispatch(FormActions.showErrorsStart());
  //     e.preventDefault();
  //   }
  // };

  return (
    <>
      {/* <ForceModal
        downloadXMLUrl={downloadXMLUrl}
        downloadFileName={fileName || downloadFileName}
      /> */}
      <div className="status-bar">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center flex-wrap p-2">
            <button
              className="btn btn-link light"
              type="submit"
              onClick={() => setValidateClicked(true)}
            >
              <i className="bi bi-patch-check" /> {t("statusBar.verifyButton")}
            </button>

            {/* <a
              className={`btn btn-link light d-md-none d-sm-inline-block ${
                isValid ? "" : "disabled"
              }`}
              href={downloadXMLUrl}
              download={fileName || downloadFileName}
              id="export-xml-link"
            >
              <i className="bi bi-file-earmark-arrow-down" />{" "}
              {t("statusBar.exportButton")}
            </a> */}

            <div className="status-area">
              {!isError && validateClicked && (
                <div className="status-msg">
                  <span className="text-success">
                    <i className="bi bi-check-lg" />{" "}
                    {t("statusBar.allValidStatus")}
                  </span>
                </div>
              )}
              {isOnlyEpisodeError && validateClicked && (
                <div className="status-msg">
                  <span className="text-success">
                    <i className="bi bi-check-lg" />{" "}
                    {t("statusBar.generalValidStatus")}
                  </span>
                </div>
              )}
              {invalidEpisodes !== 0 && validateClicked && (
                <div className="status-msg">
                  <span className="text-danger">
                    <i className="bi bi-exclamation-circle-fill" />{" "}
                    {invalidEpisodes === 1
                      ? t("statusBar.episodeInvalidStatus", {
                          count: invalidEpisodes,
                        })
                      : t("statusBar.episodeInvalidStatus_plural", {
                          count: invalidEpisodes,
                        })}
                  </span>
                </div>
              )}
              {isError && !isOnlyEpisodeError && validateClicked && (
                <div className="status-msg">
                  <span className="text-danger">
                    <i className="bi bi-exclamation-circle-fill" />{" "}
                    {t("statusBar.generalInvalidStatus")}
                  </span>
                </div>
              )}
            </div>

            {/* {isValid ? (
              <a
                className={`btn btn-link light d-md-inline-block d-none`}
                href={downloadXMLUrl}
                download={fileName || downloadFileName}
                id="export-xml-link"
              >
                <i className="bi bi-file-earmark-arrow-down" />{" "}
                {t("statusBar.exportButton")}
              </a>
            ) : (
              <button
                className={`btn btn-link light d-md-inline-block d-none`}
                id="export-xml-link"
                type="submit"
                data-bs-toggle="modal"
                data-bs-target="#forceExport"
                onClick={() => {
                  setValidateClicked(true);
                }}
              >
                <i className="bi bi-file-earmark-arrow-down" />{" "}
                {t("statusBar.exportButton")}
              </button>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusBar;
